/** UTF-8 byte-order mark; prepended so Excel decodes non-ASCII correctly. */
const BOM = "\uFEFF";

function escapeField(value: string): string {
  let escaped = value;
  if (/^[=+\-@\t\r]/.test(escaped)) escaped = `'${escaped}`;
  if (/[",\r\n]/.test(escaped)) {
    return `"${escaped.replace(/"/g, '""')}"`;
  }
  return escaped;
}

/** Build RFC-4180 CSV while neutralizing spreadsheet formula injection. */
export function toCsv(headers: string[], rows: string[][]): string {
  return [headers, ...rows]
    .map((row) => row.map(escapeField).join(","))
    .join("\r\n");
}

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([BOM, csv], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
